import { Component, inject, Input, OnChanges } from '@angular/core';
import { Router } from '@angular/router';
import { IEntitySegmentQuery, describeFilters } from '../segment-utilities';
import { SegmentService } from '../../../../services/segments/segment-service.service';
import { DataTableComponent } from '../../../ui/data-table/data-table.component';
import { EmptyStateComponent } from '../../../ui/empty-state/empty-state.component';
import { formatWhen } from '../../../../../utils/sms';

interface CopyRow {
  segment: IEntitySegmentQuery;
  key: string;
  name: string;
  rule: string;
  created: string;
}

@Component({
  selector: 'select-existing-rule-table',
  standalone: true,
  imports: [DataTableComponent, EmptyStateComponent],
  templateUrl: './select-existing-rule-table.component.html',
  styleUrl: './select-existing-rule-table.component.css',
})
export class SelectExistingRuleTableComponent implements OnChanges {
  @Input() segments: IEntitySegmentQuery[] = [];
  @Input() loading = false;
  @Input() searchTerm = '';
  segmentService = inject(SegmentService);
  router = inject(Router);

  rows: CopyRow[] = [];

  handleUseExistingRule(segment: IEntitySegmentQuery) {
    this.segmentService.handleUseAnExistingSegment(segment);
    this.router.navigate(['/organization/contacts/segmented-list/create'], {
      queryParams: { title: 'rule' },
    });
  }

  ngOnChanges() {
    this.rows = (this.segments ?? [])
      .filter((segment) => !!segment)
      .map((segment, index) => ({
        segment,
        key: segment.uuid ? String(segment.uuid) : `row-${index}`,
        name: (segment.name ?? '').toString().trim() || 'Untitled segment',
        rule: describeFilters(segment.entitySegmentQueryFilters),
        created: formatWhen(segment.createdAt),
      }));
  }
}
